import { Card, Row, Col } from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import Button from "../../../Helpers/Button/Button";
import trans from "../../../../utils";
import { useFormikContext } from "formik";
import { Input, TextAreaInput } from "../../../Helpers/Input/Input";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";

const skillLevels = [
  { label: "Beginner", value: "beginner" },
  { label: "Intermediate", value: "intermediate" },
  { label: "Advanced", value: "advanced" },
  { label: "Expert", value: "expert" },
];

export default function SkillsFormSection() {
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();
  const skills = values.skills || [];

  const addSkill = () => {
    const newSkills = [
      ...skills,
      {
        skill: "",
        skill_level: "",
        description: "",
        certificate: [],
      },
    ];
    setFieldValue("skills", newSkills);
  };

  const updateSkill = (index, field, value) => {
    const updatedSkills = [...skills];
    updatedSkills[index][field] = value;
    setFieldValue("skills", updatedSkills);
  };

  const removeSkill = (index) => {
    const updatedSkills = skills.filter((_, i) => i !== index);
    setFieldValue("skills", updatedSkills);
  };

  return (
    <div className="skills-section">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">{trans("Skills")}</h5>
        <Button type="default" icon={<PlusOutlined />} onClick={addSkill}>
          {trans("Add Skill")}
        </Button>
      </div>

      {skills.map((skill, index) => {
        const skillErrors = errors.skills?.[index] || {};
        const skillTouched = touched.skills?.[index] || {};
        console.log(skillErrors, skillTouched);
        return (
          <Card
            key={index}
            size="small"
            style={{
              marginBottom: 16,
              border: "1px solid #d9d9d9",
              borderRadius: 8,
            }}
            title={skill.skill ? skill.skill : `Skill ${index + 1}`}
            extra={
              <Button
                type="text"
                icon={<DeleteOutlined />}
                className={"remove-skill"}
                danger
                onClick={() => removeSkill(index)}
              />
            }
          >
            <Row gutter={16}>
              <Col span={12}>
                <Input
                  title={trans("Skill")}
                  type="text"
                  placeholder={trans("Enter skill name")}
                  formstyle="form-input"
                  id={`skills[${index}].skill`}
                  name={`skills[${index}].skill`}
                  value={skill.skill}
                  onBlur={handleBlur}
                  errors={skillErrors.skill}
                  touched={skillTouched.skill}
                  onChange={(e) => updateSkill(index, "skill", e.target.value)}
                />
              </Col>
              <Col span={12} className="select-z-index">
                <InputSelect
                  id={`skills[${index}].skill_level`}
                  name={`skills[${index}].skill_level`}
                  label={trans("Skill Level")}
                  placeholder={trans("Select Skill Level")}
                  options={skillLevels}
                  value={skill.skill_level}
                  onChange={(val) => updateSkill(index, "skill_level", val)}
                  onBlur={handleBlur}
                  errors={skillErrors.skill_level}
                  touched={skillTouched.skill_level}
                  formstyle="form-input"
                />
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <TextAreaInput
                  title={trans("Description")}
                  id={`skills[${index}].description`}
                  name={`skills[${index}].description`}
                  rows={3}
                  placeholder={trans("Describe this skill")}
                  value={skill.description}
                  onChange={(e) =>
                    updateSkill(index, "description", e.target.value)
                  }
                />
              </Col>
            </Row>
          </Card>
        );
      })}
    </div>
  );
}
